import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import userContext from "../../../contexts/user";
import styles from "./appNavigation.module.css";

const AppNavigation = () => {
  const [userState] = useContext(userContext);
  const [currentApp, setCurrentApp] = useState(null);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (["call-bot", "web-app", "allo-brain"].includes(userState.currentApp)) {
      setCurrentApp(userState.currentApp);
    } else {
      setCurrentApp(null);
    }
  }, [userState.currentApp]);

  useEffect(() => {
    if (!currentApp) {
      setHovered(true);
    } else {
      setHovered(false);
    }
  }, [currentApp]);

  const handleAppClick = (app) => {
    setCurrentApp(app);
    navigate(`/${app}`, { state: { refresh: true }, replace: true });
    window.location.reload();
  };

  const getOtherApps = () => {
    let apps = ["call-bot", "web-app", "allo-brain"];
    let otherApps = apps.filter((app) => app !== currentApp);
    return otherApps.map((app) => (
      <span
        className={`${styles.hidden_app} ${styles.app}`}
        onClick={() => handleAppClick(app)}
      >
        {app}
      </span>
    ));
  };

  return (
    <div
      className={styles.app_container}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => (currentApp ? setHovered(false) : null)}
    >
      {currentApp && (
        <span className={`${styles.active_app} ${styles.app}`}>
          {currentApp || "Select an app"}
        </span>
      )}

      <div className={`${styles.hidden_apps} ${hovered ? styles.visible : ""}`}>
        {getOtherApps()}
      </div>
    </div>
  );
};

export default AppNavigation;
